import * as React from 'react';
import customIconWrapper from './custom-icons';

const CloseIcon = customIconWrapper(<>
	<path d="M7.75732 7.75732L16.2426 16.2426" stroke='currentColor' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M7.75739 16.2426L16.2427 7.75732" stroke='currentColor' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</>);

export default CloseIcon;